type Callback = () => void;

class GoogleMapsAPI {
    private apiKey: string;
    private initialized: boolean = false;
    private active: boolean = false;
    private callbacks: Callback[] = [];

    initialize(apiKey: string) {
        if (!this.isInitialized && apiKey?.length > 0) {
            this.apiKey = apiKey;
            const INIT_CALLBACK = 'GoogleMapsAPI_InitializationCallback';

            window[INIT_CALLBACK] = () => {
                this.active = true;
                while (this.callbacks.length > 0) {
                    this.callbacks.shift()();
                }
            };

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${INIT_CALLBACK}`;
            script.async = true;
            document.head.appendChild(script);

            this.initialized = true;
        }

        return this;
    }

    whenActive(callback: Callback) {
        if (this.active) {
            callback();
        } else {
            this.callbacks.push(callback);
        }
    }

    public get isInitialized(): boolean {
        return this.initialized;
    }

    public get isActive(): boolean {
        return this.active;
    }

    public get key(): string {
        return this.apiKey;
    }
}

export default new GoogleMapsAPI().initialize(process.env.MIX_GOOGLE_MAPS_API_KEY);
